@if (!isLoading) {
    @if (webinarsLoadErrorMessage) {
        <div class="client-container">
            <section class="list-error-state" role="alert" aria-live="assertive">
                <h2 class="m-0 f-s-18 f-w-600">Unable to load webinars</h2>
                <p class="m-0">{{ webinarsLoadErrorMessage }}</p>
                <button
                        aria-label="Retry loading webinars"
                        class="input-like-btn new-webinar-btn"
                        color="primary"
                        mat-flat-button
                        type="button"
                        (click)="refresh()"
                >
                    Retry
                </button>
            </section>
        </div>
    } @else {
        <div class="client-container">
            <app-webinars-list
                    (create)="createWebinar()"
                    (refresh)="refresh()"
                    (searchChange)="onSearchTerm($event)"
                    (seriesSelected)="openSeries($event)"
                    (webinarSelected)="openWebinar($event)"
                    (statusFilterChange)="setStatusFilter($event)"
                    [filterTerm]="filterTerm"
                    [series]="series"
                    [seriesLoadErrorMessage]="seriesLoadErrorMessage"
                    [statusCounts]="statusCounts"
                    [statusFilter]="statusFilter"
                    [statusMeta]="statusMeta"
                    [webinars]="webinars"
            ></app-webinars-list>
        </div>
    }
} @else {
    <div class="webinars-admin__loading">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
}
